import { Navigate, Outlet, useLocation } from 'react-router';
import { hasSessionHint, useMeQuery } from '../api/auth';
import { ErrorState } from '../components/ui/States';
import { SessionProvider } from './session';

export function AppLoading({ label = 'Завантаження' }: { label?: string }) {
  return (
    <div role="status" aria-label={label} className="flex min-h-dvh items-center justify-center bg-canvas">
      <div className="flex flex-col items-center gap-3">
        <span className="flex size-9 items-center justify-center rounded-md bg-accent text-lead font-semibold text-on-accent" aria-hidden>
          Є
        </span>
        <span className="text-meta text-fg-3">{label}…</span>
      </div>
    </div>
  );
}

/** Захищена частина застосунку: без сеансу — на сторінку входу з поверненням назад. */
export function RequireAuth() {
  const hint = hasSessionHint();
  const me = useMeQuery(hint);
  const location = useLocation();
  if (hint && me.isLoading) return <AppLoading />;
  if (hint && me.error)
    return (
      <div className="flex min-h-dvh items-center justify-center bg-canvas p-4">
        <div className="w-full max-w-lg rounded-lg border border-line bg-surface">
          <ErrorState error={me.error} onRetry={() => void me.refetch()} />
        </div>
      </div>
    );
  if (!me.data) {
    const redirect = location.pathname + location.search;
    return <Navigate to={`/login${redirect && redirect !== '/' ? `?redirect=${encodeURIComponent(redirect)}` : ''}`} replace />;
  }
  return (
    <SessionProvider me={me.data}>
      <Outlet />
    </SessionProvider>
  );
}
